import React from "react";
import './Contact.css'
import GeenaJackson_Resume_2024 from './assets/GeenaJackson_Resume_2024.pdf'

const Contact = () => {
  return (
    <section className='contact-container'>
      <h1 className='contact-title'>LET'S CONNECT</h1>
      <div className="hr"></div>
      <div className="details-container">
        <span>EMAIL: <a href="mailto:gjacks303@gmail.com" className='link' target='blank'> gjacks303@gmail.com</a></span>
        <span>RESUME: <a href={GeenaJackson_Resume_2024} target='blank' className='link' rel='noreferrer'>resume</a></span>
        <span>SOCIALS: <a href="https://www.linkedin.com/in/geena-jackson/" target='blank' className="link">linkedin</a>, <a href="https://github.com/gjax78" target='blank' className='link' rel='noreferrer'>github</a>, <a href="https://medium.com/@gjacks303" target='blank' className='link' rel='noreferrer'>blog</a>
        </span>
      </div>
    </section>
  )
} 

export default Contact